import {
    type GetUserForAdminResponseType,
    type GetUserForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const getUserForAdmin = async (params: GetUserForAdminRequestType): Promise<GetUserForAdminResponseType> => {
    const queryStr = params ? `?${new URLSearchParams(params as Record<string, string>).toString()}` : "";
    return await request<GetUserForAdminResponseType>(`/user/getUserForAdmin${queryStr}`, {
        method: "GET"
    });
};
export default getUserForAdmin;
